(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/transcript-panel/components/transcript-ordered-download.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/transcript-panel/components/transcript-ordered-download.js');
'use strict';

const downloadUrlBase = svs.core.jupiter.url();
const Icon = svs.ui.ReactIcon;
const {
  TopBottomBorder
} = svs.myProfile.react.pages.myInformation.transcript;

const TranscriptOrderedDownload = _ref => {
  let {
    customerTranscript
  } = _ref;
  const isNativeApp = svs.core.config.data.svsconfig.isNativeApp;
  const myProfileHomeUrl = svs.core.urlMapping.get('myProfileHome');
  const appDownloadUrl = "".concat(myProfileHomeUrl, "/uppgifter/registerutdrag/ladda-ner/").concat(customerTranscript.OrderId, "/Registerutdrag.zip");
  const webDownloadUrl = "".concat(downloadUrlBase, "/minc-proxy/v1/transcript/").concat(customerTranscript.OrderId);
  const convertToDate = string => dateFns.format(new Date(string), 'yyyy-MM-dd', {
    locale: dateFns.locales.sv
  });
  return React.createElement(TopBottomBorder, null, React.createElement("a", {
    className: "u-flex",
    href: isNativeApp ? appDownloadUrl : webDownloadUrl
  }, React.createElement("span", {
    className: "u-flex-grow-1 u-block"
  }, "Registerutdrag"), React.createElement("span", {
    className: "u-flex-grow-1 u-block u-text-decoration-none fc-navy"
  }, "Best\xE4llt:", ' ', convertToDate(customerTranscript.OrderDate)), React.createElement("span", {
    className: "u-flex-shrink-1 u-text-decoration-none padding-h fc-navy"
  }, ".ZIP"), React.createElement("span", {
    className: "u-flex-shrink-1 padding-h"
  }, React.createElement(Icon, {
    className: "u-align-middle",
    icon: "document",
    size: "200"
  }))));
};
svs.myProfile.react.pages.myInformation.transcript.TranscriptOrderedDownload = TranscriptOrderedDownload;

 })(window);